import { makeStyles } from '@material-ui/core';
import {
	poppins,
	lightBlack,
	fontGrey,
	roboto,
	white,
	mainRed,
	mainRed50
} from '../../../../styles/variables';

export const CARD_SIZE = '180px';
const SPACE_BETWEEN_CARDS = '20px';

export const useStyles = makeStyles(() => ({
	container: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: '1rem',
		flexDirection: 'column'
	},
	labels: {
		display: 'flex',
		paddingTop: '1rem',
		paddingBottom: '1rem',
		justifyContent: 'space-between',
		width: (props: { cardCount: number }) =>
			`calc(${props.cardCount} * ${CARD_SIZE} + ${
				props.cardCount - 1
			} * ${SPACE_BETWEEN_CARDS})`
	},
	labelItem: {
		width: CARD_SIZE,
		textAlign: 'center',
		fontFamily: poppins,
		fontSize: '2.6rem',
		fontWeight: 'bold',
		lineHeight: '1.25',
		letterSpacing: '1.2px',
		color: lightBlack
	},
	list: {
		display: 'flex',
		justifyContent: 'space-between',
		width: (props: { cardCount: number }) =>
			`calc(${props.cardCount} * ${CARD_SIZE} + ${
				props.cardCount - 1
			} * ${SPACE_BETWEEN_CARDS})`,
		marginTop: '0.25rem'
	},
	card: {
		width: CARD_SIZE,
		userSelect: 'none',
		height: CARD_SIZE,
		marginRight: SPACE_BETWEEN_CARDS, // important value for smooth dnd
		textAlign: 'center'
	},
	instruction: {
		marginTop: '2rem',
		textAlign: 'center',
		fontFamily: roboto,
		fontSize: '1.2rem',
		lineHeight: '1.25',
		letterSpacing: '0.5px',
		color: fontGrey
	},
	button: {
		marginTop: '2rem',
		width: '21rem',
		height: '3rem',
		fontFamily: poppins,
		fontWeight: 600,
		letterSpacing: '0.45px',
		color: white,
		backgroundColor: mainRed,
		'&:hover': {
			backgroundColor: mainRed50,
			color: white
		}
	}
}));
